var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 8.18V5.3C8.8 5.07333 8.72333 4.88333 8.57 4.73C8.41667 4.57667 8.22667 4.5 8 4.5C7.77333 4.5 7.58333 4.57667 7.43 4.73C7.27667 4.88333 7.2 5.07333 7.2 5.3V8.48C7.2 8.58667 7.22 8.69 7.26 8.79C7.3 8.89 7.36 8.98 7.44 9.06L10.08 11.7C10.2267 11.8467 10.4133 11.92 10.64 11.92C10.8667 11.92 11.0533 11.8467 11.2 11.7C11.3467 11.5533 11.42 11.3667 11.42 11.14C11.42 10.9133 11.3467 10.7267 11.2 10.58L8.8 8.18ZM8 16.5C6.89333 16.5 5.85333 16.29 4.88 15.87C3.90667 15.45 3.06 14.88 2.34 14.16C1.62 13.44 1.05 12.5933 0.63 11.62C0.21 10.6467 0 9.60667 0 8.5C0 7.39333 0.21 6.35333 0.63 5.38C1.05 4.40667 1.62 3.56 2.34 2.84C3.06 2.12 3.90667 1.55 4.88 1.13C5.85333 0.71 6.89333 0.5 8 0.5C9.10667 0.5 10.1467 0.71 11.12 1.13C12.0933 1.55 12.94 2.12 13.66 2.84C14.38 3.56 14.95 4.40667 15.37 5.38C15.79 6.35333 16 7.39333 16 8.5C16 9.60667 15.79 10.6467 15.37 11.62C14.95 12.5933 14.38 13.44 13.66 14.16C12.94 14.88 12.0933 15.45 11.12 15.87C10.1467 16.29 9.10667 16.5 8 16.5Z",
    fill: "#323338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/TimeIcon.df7f3fffaf7823174adc10768658ae9f.svg";
export { ForwardRef as ReactComponent };